import Button from "app/components/UI/Button";
import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import PropTypes from "prop-types";
import React from "react";
import classes from "./List.module.css";
import classnames from "classnames";

export const ListItem = ({ title, subtitle, right, mediaUrl, mediaName, onAction, labelAction }) => (
  <Flex direction="row" className={classes.listItem}>
    {mediaUrl && (
      <div
        className={classes.listItem__media}
        style={{
          backgroundImage: `url(${mediaUrl})`
        }}
      />
    )}

    <Flex direction="column" size={1} className={classes.listItem__content}>
      <Flex size={1} className={classes.listItem__content_head}>
        <div className={classes.listItem__title}>{title}</div>
        {subtitle && (
          <div className={classes.listItem__subtitle} title={subtitle}>
            {subtitle}
          </div>
        )}
      </Flex>

      <Flex direction="row" middle className={classes.listItem__content_bottom}>
        {onAction && (
          <Flex size={3}>
            <Button.Flat
              label={
                <span className={classes.deleteButton}>
                  {labelAction}
                  <Icon>delete</Icon>
                </span>
              }
              onClick={onAction}
            />
          </Flex>
        )}

        {right && (
          <Flex size={1} className={classnames(classes.listItem__right)}>
            {right}
          </Flex>
        )}
      </Flex>
    </Flex>
  </Flex>
);

ListItem.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  right: PropTypes.node,
  onAction: PropTypes.func,
  labelAction: PropTypes.string,
  mediaUrl: PropTypes.string,
  mediaName: PropTypes.string
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/app/components/UI/List/ListItem.js